import { render, staticRenderFns } from "./inspectionCategory.vue?vue&type=template&id=3eed7b8e"
import script from "./inspectionCategory.vue?vue&type=script&lang=js"
export * from "./inspectionCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports